import React from 'react';

import { withLocalize } from "react-localize-redux";

class IconDocumentStatus extends React.Component{

    // progression
    // validationInformation
    // infovisible
    // kind
    // isincompleted

    constructor(props){
        super(props);
        this.state = {
        }
      }



    GetProgressionColor(){
        if (!this.props.progression || this.props.progression < 25){
            return '#CF3440'
        }
        else if (this.props.progression < 50){
            return '#FF4D00'
        }
        else if (this.props.progression < 75){
            return '#FF9100'
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_rejected"){
            return '#CF3440'
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_expired") {
            return '#CF3440'
        }
        else if (this.props.validationInformation.validationStatus !== "document_validation_status_validated"){
            return '#FFEA00'
        }
        else {
            return '#99CC66'
        }
    }
  

    ShowInfo(mode){

        if ((this.props.infovisible === "true" && mode === "tooltip") || (this.props.infovisible === "false" && mode === "title")) {
            return ""
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_initialized"){
            return this.props.translate('validation.notification.initialized')
                    .replace('<TIMESTAMP>',this.props.validationInformation.timestamp)
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_draft" && this.props.progression === 100 ){
            return this.props.translate('validation.notification.draftedAndFilled')
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_draft"){
            return this.props.translate('validation.notification.drafted')
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_rejected"){
            return this.props.translate('validation.notification.rejected')
                    .replace('<VALIDATOR>',this.props.validationInformation.user)
                    .replace('<TIMESTAMP>',this.props.validationInformation.timestamp)
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_submitted"){
            return this.props.translate('validation.notification.submitted')
                    .replace('<VALIDATOR>',this.props.validationInformation.validator)
                    .replace('<TIMESTAMP>',this.props.validationInformation.timestamp)
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_expired") {
            return this.props.translate('validation.notification.expired')
                .replace('<TIMESTAMP>', this.props.validationInformation.timestamp)
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_validated"){
            return this.props.translate('validation.notification.validated')
                    .replace('<VALIDATOR>',this.props.validationInformation.user)
                    .replace('<TIMESTAMP>',this.props.validationInformation.timestamp)
        }
        else if (this.props.isincompleted === true && this.props.kind === "project"){
            return this.props.translate("content.information.document-validation-status.project-incompleted")
        }
        else if (this.props.progression < 50){
            return this.props.translate("content.information.document-validation-status.incompleted")
        }

        else{      
            return this.props.translate("content.information.document-validation-status.not-validated")
        }
    }


    GetIcon(){

        if (this.props.validationInformation.validationStatus === "document_validation_status_initialized" || this.props.validationInformation.validationStatus === "document_validation_status_rejected"){
            return <div key={"check"} className="validation-icon">
                <i  className="fas fa-exclamation-triangle" title={this.ShowInfo("tooltip")}  style={{marginRight:"10px", marginLeft:"10px"}}></i>
            </div>
        }
        if (this.props.validationInformation.validationStatus === "document_validation_status_draft"){
            return <div key={"check"} className="validation-icon">
                <i  className="fas fa-file-signature" title={this.ShowInfo("tooltip")}  style={{marginRight:"10px", marginLeft:"10px"}}></i>
            </div>
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_submitted") {
            return <div key={"check"} className="validation-icon">
                        <i className="fas fa-solid fa-clock" title={this.ShowInfo("tooltip")} style={{marginRight:"10px", marginLeft:"10px"}}></i>
                    </div>
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_validated") {
            return <div key={"check"} className="validation-icon">
                <i  className="fas fa-solid fa-check" title={this.ShowInfo("tooltip")}  style={{marginRight:"10px", marginLeft:"10px"}}></i>
                </div>
        }
        else if (this.props.validationInformation.validationStatus === "document_validation_status_expired") {
            return <div key={"check"} className="validation-icon">
                <i className="fas fa-hourglass-end" title={this.ShowInfo("tooltip")} style={{ marginRight: "10px", marginLeft: "10px" }}></i>
            </div>
        }
        else {
            return <div key={"clock"} className="validation-icon">
                <i className="fas fa-solid fa-clock" title={this.ShowInfo("tooltip")} style={{marginRight:"10px", marginLeft:"10px"}}></i>
                </div>
        }
    }

    GetIconWithColor(){
        
        
        return (
                    <div style={{'color':this.GetProgressionColor(), 'fontSize':"14px"}} >
                        {this.GetIcon()}
                        {this.ShowInfo("title")}
                    </div>
        );
    }

    render(){

        // Consultant information validated by {this.props.consultant.validationInformation.managerFullName} in {this.props.consultant.validationInformation.lastValidation}
        return (
            this.GetIconWithColor()
        )
    }
  }
  
  
  export default withLocalize(IconDocumentStatus);
  